import React,{ useEffect } from 'react';
import { useDispatch } from "react-redux";
import { setScreenWidth } from "../actions/HeaderActions";
import SessionTimeOut from "../components/SessionTimeOut";
function PageLayoutWrapper(props){
    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(setScreenWidth(window.screen.width))
    },[]);

    window.onresize = function(){
        dispatch(setScreenWidth(window.screen.width));
    }
    window.addEventListener('orientationchange', function(){}, false); 
    return(<>
            <div className="main-body" role="main">
                <SessionTimeOut/>
                {props.children}
            </div>
        </>
    )
}

export default PageLayoutWrapper;


